<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Reservados X Retirados
                <a
                  data-toggle="collapse"
                  href="#collapseFilter"
                  aria-expanded="false"
                  aria-controls="collapseFilter"
                  class="btn-filter"
                  >Filtros <i class="fas fa-filter"></i
                ></a>
              </div>
            </div>
            <div class="card-body">
              <div class="collapse" id="collapseFilter">
                <div class="row mb-3">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartSpot">Filial</label>
                      <v-select
                        :options="branches"
                        label="description"
                        :reduce="(branches) => branches.id"
                        class="style-chooser"
                        v-model="filter.branch_id"
                      >
                        <div slot="no-options">Carregando...</div>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateStart">Data Início</label>
                      <CtkDateTimePicker
                        v-model="filter.retreat_date"
                        color="orange"
                        locale="pt-br"
                        no-label
                        only-date
                        button-now-translation="Hoje"
                        class="datetimepicker"
                        label="Selecione a data de retirada"
                        format="YYYY-MM-DD hh:mm:ss"
                        id="retreat_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="chartDateEnd">Data Final</label>
                      <CtkDateTimePicker
                        v-model="filter.devolution_date"
                        color="orange"
                        locale="pt-br"
                        no-label
                        only-date
                        button-now-translation="Hoje"
                        class="datetimepicker"
                        label="Selecione a data de devolução"
                        format="YYYY-MM-DD hh:mm:ss"
                        id="devolution_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-add"
                      @click="filterDashboard()"
                    >
                      Filtrar
                    </button>
                  </div>
                </div>
              </div>
              <div id="app">
                <ChartBar
                  v-if="renderComponent"
                  :chart-data="chartData"
                  :options="options"
                />
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col" width="40%">Mês</th>
                      <th scope="col" width="20%">Reservados</th>
                      <th scope="col" width="20%">Retirados</th>
                      <th scope="col" width="20%">Percentual de Compromisso</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in datas" :key="data.month">
                      <td>{{ data.monthName }}</td>
                      <td>{{ data.reserveds }}</td>
                      <td>{{ data.devoluteds }}</td>
                      <td>{{ data.percent }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBar from "@/components/Utils/ChartBar.js";
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
  name: "App",
  data() {
    return {
      chartData: null,
      loaded: false,
      months: ["a", "b", "c"],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
      chartData: {
        labels: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dez",
        ],
        datasets: [
          {
            label: "Reservados",
            backgroundColor: "#FFB22B",
            borderColor: "#FFB22B",
            borderWidth: 3,
            radius: 5,
            data: [0, 25, 50, 75, 100, 125],
          },
          {
            label: "Retirados",
            backgroundColor: "#1B9E77",
            borderColor: "#1B9E77",
            borderWidth: 4,
            radius: 5,
            pointBorderColor: "1B9E77",
            data: [0, 25, 50, 75, 100, 125],
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },

      datas: [],
      branches: [],
      filter: {},
      renderComponent: false,
    };
  },
  methods: {
    getDashboards: function (id) {
      const self = this;
      const api = self.$store.state.api + "dashboardOne";

      self.$http
        .get(api)
        .then((response) => {
          self.datas = response.data.table;

          self.chartData.labels = response.data.months;
          self.chartData.datasets[0].data = response.data.reserveds;
          self.chartData.datasets[1].data = response.data.devoluteds;

          this.renderComponent = true;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    filterDashboard: function () {
      this.renderComponent = false;

      this.chartDatas = ["Mês", "Reservados", "Retirados"];

      const self = this;
      const api = self.$store.state.api + "dashboardOne";

      var data_1 = new Date(this.filter.retreat_date);
      var data_2 = new Date(this.filter.devolution_date);

      if (
        this.filter.branch_id != null ||
        this.filter.branch_id != "" ||
        this.filter.retreat_date == "" ||
        this.filter.devolution_date == "" ||
        this.filter.retreat_date == null ||
        this.filter.devolution_date == null
      ) {
        swal("Erro", "Você precisa selecionar uma data para filtrar", "error");
        return;
      }

      if (
        this.filter.branch_id == "" ||
        this.filter.retreat_date == "" ||
        this.filter.devolution_date == "" ||
        this.filter.retreat_date == null ||
        this.filter.devolution_date == null
      ) {
        const self = this;
        let fd = new FormData();

        fd.append("_method", "GET");
        fd.append(
          "retreat_date",
          self.filter.retreat_date ? self.filter.retreat_date : ""
        );
        fd.append(
          "devolution_date",
          self.filter.devolution_date ? self.filter.devolution_date : ""
        );
        fd.append("branch_id", self.filter.branch_id);

        self.$http
          .post(api, fd)
          .then((response) => {
            self.datas = response.data.table;
            self.chartData.labels = response.data.months;
            self.chartData.datasets[0].data = response.data.reserveds;
            self.chartData.datasets[1].data = response.data.devoluteds;

            this.renderComponent = true;
          })
          .catch((error) => {
            self.$message(null, "erro", "error");
          });
      } else {
        if (data_1 > data_2) {
          swal(
            "Erro",
            "Data inicial não pode ser maior que data final",
            "error"
          );
        } else {
          const self = this;

          let fd = new FormData();

          fd.append("_method", "GET");
          fd.append("retreat_date", self.filter.retreat_date);
          fd.append("devolution_date", self.filter.devolution_date);
          fd.append("branch_id", self.filter.branch_id);

          self.$http
            .post(api, fd)
            .then((response) => {
              self.datas = response.data.table;
              self.chartData.labels = response.data.months;
              self.chartData.datasets[0].data = response.data.reserveds;
              self.chartData.datasets[1].data = response.data.devoluteds;

              this.renderComponent = true;
            })
            .catch((error) => {
              self.$message(null, "erro", "error");
            });
        }
      }
    },

    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getDashboards();
    self.getBranches();
  },

  components: {
    ChartBar,
    vSelect,
    CtkDateTimePicker,
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Indicators/reserved_retreat.vue